import { compact } from "lodash-es";
import { useMemo } from "react";
import { SystemConfigLayout } from "../../components/SystemConfigLayout";
import { TabbedRoutes } from "../../components/TabbedRoutes";
import { useUpdatePermission } from "../../utils";
import { AvailityErrorRulesTab } from "./tabs/AvailityErrorRulesTab";
import { RankOrderTab } from "./tabs/RankOrderTab";

export const AvailityErrorRulesPage = () => {
  const [canUpdate] = useUpdatePermission("AvailityErrorRule");
  const tabs = useMemo(
    () =>
      compact([
        { path: "rules", label: "Rules", Component: AvailityErrorRulesTab },
        canUpdate ? { path: "order", label: "Rank Order", Component: RankOrderTab } : undefined,
      ]),
    [canUpdate]
  );

  return (
    <SystemConfigLayout title={["Automation", "Availity Error Handling"]}>
      <TabbedRoutes tabs={tabs} defaultTab="rules" />
    </SystemConfigLayout>
  );
};
